import { Orde } from './Orde'
import { BatchId } from '../Batch'
import { IsolatesMode } from './IsolatesMode'
import { Mountain } from './Mountain'
import { Owner } from './Owner'
import { Location } from './Location'
import { Lumberjack } from './Lumberjacks/Lumberjack'
import { Fase } from './Fase'
import { Surface } from './Surface'
import { Taxes } from './Taxes'

export class Tracking {
  private _orde: Orde | null
  private _barchId: BatchId
  private _fase: Fase
  private _isolatesMode: IsolatesMode
  private _mountain: Mountain
  private _owner: Owner
  private _location: Location
  private _surface: Surface
  private _taxes: Taxes
  private _lumberjack: Lumberjack[]

  constructor (
    orde: Orde | null,
    batchId: BatchId,
    fase: Fase,
    isolatesMode: IsolatesMode,
    mountain: Mountain,
    owner: Owner,
    location: Location,
    surface: Surface,
    taxes: Taxes,
    lumberjack: Lumberjack []
  ) {
    this._orde = orde
    this._barchId = batchId
    this._fase = fase
    this._isolatesMode = isolatesMode
    this._mountain = mountain
    this._owner = owner
    this._location = location
    this._surface = surface
    this._taxes = taxes
    this._lumberjack = lumberjack || []
  }

  orde (): number | null {
    return this._orde === null ? null : this._orde.orde()
  }

  batchId (): string {
    return this._barchId.batchId()
  }

  recordId (): string {
    return this._barchId.recordId()
  }

  fase (): string {
    return this._fase.fase()
  }

  isolatesMode (): string {
    return this._isolatesMode.isolatesMode()
  }

  mountain (): string {
    return this._mountain.mountain()
  }

  owner (): string {
    return this._owner.owner()
  }

  location (): string {
    return this._location.location()
  }

  surface (): string {
    return this._surface.surface()
  }

  taxes (): string {
    return this._taxes.taxes()
  }

  lumberjack (): Lumberjack [] {
    return this._lumberjack
  }
}
